import { NonRetriableError } from './DataExtraction';
import { MANAGE_REVIEWERS_ROUTE, tokenizeRoute } from 'query/routes';
import { getCsrfToken } from 'util/authenticityToken';

type ManageReviewersParams = {
  studyId: number;
  reviewId: string;
  keepPrimaryReviewerData: boolean | null;
  keepSecondaryReviewerData: boolean | null;
  primaryReviewerId: number | null;
  secondaryReviewerId: number | null;
};

export const manageReviewers = ({
  studyId,
  reviewId,
  keepPrimaryReviewerData,
  keepSecondaryReviewerData,
  primaryReviewerId,
  secondaryReviewerId,
}: ManageReviewersParams) => {
  const url = tokenizeRoute(MANAGE_REVIEWERS_ROUTE, {
    study_id: studyId,
    review_id: reviewId,
  });

  const body: any = {
    keep_primary_reviewer_data: keepPrimaryReviewerData,
    keep_secondary_reviewer_data: keepSecondaryReviewerData,
    primary_reviewer_id: primaryReviewerId,
    secondary_reviewer_id: secondaryReviewerId,
  };

  return fetch(url.toString(), {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
    body: JSON.stringify(body),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new NonRetriableError(String(response.status));
  });
};
